/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ReplyListCommentContainer_comment = {
    readonly enteredLive: boolean | null;
    readonly " $fragmentRefs": FragmentRefs<"CommentContainer_comment" | "IgnoredTombstoneOrHideContainer_comment">;
    readonly " $refType": "ReplyListCommentContainer_comment";
};
export type ReplyListCommentContainer_comment$data = ReplyListCommentContainer_comment;
export type ReplyListCommentContainer_comment$key = {
    readonly " $data"?: ReplyListCommentContainer_comment$data;
    readonly " $fragmentRefs": FragmentRefs<"ReplyListCommentContainer_comment">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ReplyListCommentContainer_comment",
    "selections": [
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CommentContainer_comment"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "IgnoredTombstoneOrHideContainer_comment"
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "enteredLive",
                    "storageKey": null
                }
            ]
        }
    ],
    "type": "Comment",
    "abstractKey": null
} as any);
(node as any).hash = 'b2f79c5cf5c28abbb6d8539d9561252e';
export default node;
